import React from "react";

import CTA from "./CTA";
import ME from "../../assets/me.png";
import HeaderSocials from "./HeaderSocials";

import { FiArrowDownCircle } from "react-icons/fi";

import "./header.css";
const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h3>Hi there!</h3>
        <h1>I'm Tomio Koshikawa</h1>
        <h4 className="text-light">Full-Stack Developer</h4>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="me" />
        </div>

        <a href="#contact" className="scroll__down">
          <FiArrowDownCircle size={70} />
        </a>
      </div>
    </header>
  );
};

export default Header;
